import { FunctionComponent, useContext } from "react";
import Navbar from "components/StickyMenu/NavBar";
import { ReferenceContext } from "providers/ReferenceProvider";
import styles from "./home.module.scss";
import MainFigure from "primitives/MainFigure";
import TypeWriterText from "primitives/TypewriterText";

const Home: FunctionComponent<{
  isHomePage?: boolean;
  fromHamburger?: boolean;
}> = ({ isHomePage = false, fromHamburger = false }) => {
  const { homeRef } = useContext(ReferenceContext);

  // dont recreate home references if its on mobile mode.
  const refData = fromHamburger ? {} : { ref: homeRef };

  return (
    <div {...refData} className={styles.container}>
      <p className={styles.fullNameText}>Steven Nguyen</p>
      <div className={styles.underTitle_container}>
        <p className={styles.underTitle_text}>
          Hi, I’m Steven - a software engineer with a passion for{" "}
        </p>
        <TypeWriterText />
      </div>
      <MainFigure />
      <Navbar isHomePage={isHomePage} />
    </div>
  );
};

export default Home;
